<template>
  <div class="common-layout">
    <div
      v-if="showHeader"
      style="
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 1000;
        background-color: #fff;
      "
    >
      <NavBar></NavBar>
    </div>
    <el-container>
      <el-header v-if="route.path!=='/index'">
          <NavBar></NavBar>
      </el-header>
      <el-main>
        <router-view v-if="isReload" v-slot="{ Component }">
          <transition name="fade-right" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </el-main>
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container>
    <!-- 登录弹窗 -->
    <el-dialog
      v-model="loginStore.showVisible"
      width="30%"
      :before-close="handleClose"
      top="20vh"
      :modal="true"
      draggable
    >
      <component :is="loginStore.component"></component>
      <template #footer>
        <span class="dialog-footer"> </span>
      </template>
    </el-dialog>



  </div>
</template>

<script setup>
// import { default as AppMain } from "@views/AppMain.vue";
import { onMounted, onUnmounted, reactive, provide, nextTick, ref } from "vue";
import { default as NavBar } from "@views/layout/NavBar";
import { default as Footer } from "@views/layout/Footer";
import useLogin from "@/stores/login";
import { changeThemeColor } from '@/utils/theme'
import {clickAgency, getAgencyIdByIpScope, getSiteInfoByOrgCode} from "@/request/api/index"
import useSiteInformation from "@/stores/siteInformation"
import {useRoute, useRouter} from "vue-router";
import {decrypt} from "@/js/encrypt";
import {ElMessage} from "element-plus";
const siteInformation = useSiteInformation()
changeThemeColor(siteInformation.themeColor)
const route = useRoute();



//监听滚动
const data = reactive({
  oldScrollTop: 0,
});
const showHeader = ref(false);
const scrolling = () => {
  // 滚动条距文档顶部的距离
  let scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  // 滚动条滚动的距离
  // let scrollStep = scrollTop - data.oldScrollTop;
  // console.log("header 滚动距离 ", scrollTop);
  if (scrollTop > 70) {
    showHeader.value = true;
  } else {
    showHeader.value = false;
  }
  // // 更新——滚动前，滚动条距文档顶部的距离
  // data.oldScrollTop = scrollTop;

  // //变量windowHeight是可视区的高度
  // let windowHeight =
  // document.documentElement.clientHeight || document.body.clientHeight;
  // //变量scrollHeight是滚动条的总高度
  // let scrollHeight =
  // document.documentElement.scrollHeight || document.body.scrollHeight;

  // //滚动条到底部的条件
  // if (scrollTop + windowHeight == scrollHeight) {
  // //你想做的事情
  //     console.log("header  你已经到底部了");
  // }
  // if (scrollStep < 0) {
  //     console.log("header 滚动条向上滚动了！");
  // } else {
  //     console.log("header  滚动条向下滚动了！");
  // }
  // // 判断是否到了最顶部
  // if (scrollTop <= 0) {
  //     console.log("header 到了最顶部")
  // }
};
function getPublicIP(callback) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);
      callback(response.ip);
    }
  };
  xhr.open("GET", "https://api.ipify.org?format=json", true);

  xhr.send();
}
onMounted(() => {
  const baseIP = process.env;
  // console.log(baseIP); // 输出BASE_IP的值
  localStorage.setItem("ip", baseIP.BASE_IP);
  // window.addEventListener("scroll", scrolling);
  getPublicIP(function (publicIP) {
    // console.log("本机ip:" + localStorage.getItem("ip"));
    // console.log("公网IP地址: " + publicIP);
    localStorage.setItem("publicIP", publicIP);
  });

  let res2 =  initSitInfo();
});
onUnmounted(() => {
  // window.removeEventListener("scroll", scrolling);
});

const initSitInfo = async () =>{
  let rs = await init().then(res=>{
    getSiteInfoByOrgCode().then(res =>{
      if(res.data != null){
        let data = JSON.parse(decrypt(res.data));
        console.log(data)
        let siteInfo = data.siteInfo;
        if(data.siteInfo != null){
          siteInformation.themeColor = siteInfo.themeColor
          siteInformation.siteName = siteInfo.siteName
          siteInformation.versionNumber = siteInfo.versionNumber
          siteInformation.recordNumber = siteInfo.recordNumber
          siteInformation.companyPhone = siteInfo.companyPhone
          siteInformation.companyEmail = siteInfo.companyEmail
          siteInformation.companyAddress = siteInfo.companyAddress
          siteInformation.companyWebsite = siteInfo.companyWebsite
          siteInformation.copyrightInformation = siteInfo.copyrightInformation
          siteInformation.topBarBackgroundColor = siteInfo.topBarBackgroundColor
          siteInformation.logo = siteInfo.logo
          siteInformation.onlineDuration = siteInfo.onlineDuration
          siteInformation.isShowGame = siteInfo.isShowGame
          siteInformation.topBarImg = siteInfo.topBarImg || null
          localStorage.setItem("ipInfo",data.ip);
        }else {
          Object.assign(siteInformation, {
            "agencyId": undefined,
            "siteName": "微课资源学习",
            "versionNumber": "奥思·微课资源及案例系统",
            "recordNumber": "京ICP备10010903号",
            "companyPhone": "400 073 0087",
            "companyEmail": "sales@kingchannels.com",
            "companyAddress": "北京市海淀区西三旗建材城内3幢一层107号",
            "companyWebsite": "www.kingchannels.com",
            "copyrightInformation": "©2017 中新金桥 版权所有 2006-2024",
            "onlineDuration": 50,
            "themeColor": "#EF6937",
            "topBarBackgroundColor": null,
            "logo": "https://zxjq-gx.obs.cn-east-2.myhuaweicloud.com/%E8%BD%AF%E4%BB%B6%E9%80%9A%E5%88%86%E4%BA%AB/rjt_logo.png",
            "isShowGame": true,
            "topBarImg": null
          })
        }

      }else {
        Object.assign(siteInformation, {
          "agencyId": undefined,
          "siteName": "微课资源学习",
          "versionNumber": "奥思·微课资源及案例系统",
          "recordNumber": "京ICP备10010903号",
          "companyPhone": "400 073 0087",
          "companyEmail": "sales@kingchannels.com",
          "companyAddress": "北京市海淀区西三旗建材城内3幢一层107号",
          "companyWebsite": "www.kingchannels.com",
          "copyrightInformation": "©2017 中新金桥 版权所有 2006-2024",
          "onlineDuration": 50,
          "themeColor": "#EF6937",
          "topBarBackgroundColor": null,
          "logo": "https://zxjq-gx.obs.cn-east-2.myhuaweicloud.com/%E8%BD%AF%E4%BB%B6%E9%80%9A%E5%88%86%E4%BA%AB/rjt_logo.png",
          "isShowGame": true,
          "topBarImg": null
        })
      }
    });
  });


}

const init = async ()=>{
    if(!loginStore.isLogin){
      let queryCode = getQueryString("code");
      if(queryCode!=null&&queryCode!=''){
        loginStore.code = queryCode;
      }

    }
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}


const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};


const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

const loginStore = useLogin();
const handleClose = (done) => {
  done();
};
const isReload = ref(true);
//解决路由跳转到相同页面,数据不刷新问题
const reload = () => {
  isReload.value = false;
  nextTick(() => {
    isReload.value = true;
  });
};
provide("Reload", reload);
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
:deep(.el-main) {
  background-color: $backgroundColor1;
  padding: 1vh 0;
  min-height: 80vh;
  overflow-x: hidden;
}
:deep(.el-header) {
  position: relative;
  --el-header-height: 70px;
  --el-header-padding: 0;
  background-color: #5201d7;
  background-image: url('./assets/image/line.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: left bottom;
  z-index: 1;
}
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: auto;
}
// 进入后和离开前保持原位
.fade-right-enter-to,
.fade-right-leave-from {
  opacity: 1;
  transform: none;
}

// 设置进入和离开过程中的动画时长0.5s
.fade-right-enter-active,
.fade-right-leave-active {
  transition: all 0.5s;
}

// 进入前和离开后为透明，并在右侧20px位置
.fade-right-enter-from,
.fade-right-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
:deep(.el-dialog__header) {
  padding-top: 5px;
}
:deep(.el-dialog__footer) {
  padding-bottom: 5px;
}
// :deep(.el-dialog__body){
//   padding: 0 15%;
// }
</style>
